<template>
  <div class="product-details" :data-product-id="product.id">
    <div class="description-container" v-if="product.url">
      <div class="description" v-html="product.description"></div>
      <a class="morelink" :href="product.url">{{labels.showMore}}</a>
    </div>
    <div class="ftb" v-if="!product.skipMaterials && showAllDocuments">
      <div class="ftb-selectors">
        <div
          class="ftb-selector selected"
          :data-target="getTabId(1)"
          @click="onSdsTabSelected"
        >
          <a>{{labels.tab1}}</a>
        </div>
        <div
          class="ftb-selector"
          :data-target="getTabId(2)"
          v-if="product.id"
          @click="onOtherTabSelected"
        >
          <a>{{labels.tab2}}</a>
        </div>
      </div>
      <div class="ftb-panes">
        <div
          class="ftb-pane selected"
          :id="getTabId(1)"
        >
          <div>
            <material-details :product="product"></material-details>
          </div>
        </div>
        <div
          class="ftb-pane"
          :id="getTabId(2)"
          v-if="product.id"
        >
          <product-downloads :product="product" v-if="currentTab === 1"></product-downloads>
        </div>
      </div>
    </div>
    <div v-if="!product.skipMaterials && !showAllDocuments">
      <material-details :product="product"></material-details>
    </div>
    <div v-if="product.skipMaterials" class="download-container">
      <SDSDownloads
      :material="{name: product.title, number: product.bulkNumber}"
      :pinned="true"
      @loaded="onFilesLoaded"
    ></SDSDownloads>
    </div>
  </div>
</template>

<script>
import Labels from "../services/labels.js";
import Config from "../services/config.js";
import Utils from "../services/utils.js";
import MaterialDetails from "./MaterialDetails.vue";
import ProductDownloads from "./ProductDownloads.vue";
import SDSDownloads from "./SDSDownloads.vue";

export default {
  name: "ProductDetails",
  props: ["product"],
  components: {
    MaterialDetails,
    ProductDownloads,
    SDSDownloads
  },
  data() {
    return {
      labels: Labels,
      showAllDocuments: Config.showAllDocuments,
      currentTab:
        this.$props.product.materials &&
        this.$props.product.materials.length > 0
          ? 0
          : 1
    };
  },
  mounted() {
    if (Config.showAllDocuments) {
      Utils.waitForObjects(10, "window.cla", "window.cla.assetManager").then(() => {
        let tabbox = document.querySelector(
          `.product-details[data-product-id='${this.product.id}'] .ftb`
        );
        window.cla.assetManager.loadStylesheet("/styles/components/flat-tab-box.css");
        window.cla.assetManager.loadScript(
          "/scripts/components/flat-tab-box.js",
          function() {
            if (tabbox && !tabbox.classList.contains("initialized")) {
              //this happens if the tabbox script was already loaded (so, it's not the first load of the editor)
              if (window.cla && window.cla.tabBoxes && window.cla.tabBoxes.init)
                window.cla.tabBoxes.init();
            }
            console.log("Tab box initialized");
          }
        );
      }).catch ( () => {
        console.error("Asset manager not initialized!");
      });
    }
  },
  methods: {
    onSdsTabSelected() {
      this.currentTab = 0;
    },
    onOtherTabSelected() {
      this.currentTab = 1;
    },
    getTabId(index) {
      return `ftb-tab-${this.$props.product.id.replace(
        /[\W_]+/g,
        "Z"
      )}-${index}`;
    },
    onFilesLoaded() {
      console.log("Files loaded");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.product-details {
  display: flex;
  flex-direction: column;
}

.product-details .description-container {
  margin-bottom: 20px;
}

.product-details .description-container .description {
  display: inline;
}

.product-details .description-container a.morelink {
  display: inline;
  font-size: 14px;
  margin-left: 10px;
}

.download-container {
  
}

.ftb-pane {
  min-height:30px;
}
</style>